export default "__VITE_ASSET__63518ec5__"